import {inject} from '@angular/core';
import {HttpEvent, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ConsoleAuthenticationService} from "src/app/security/console-authentication.service";
import {ConsoleContextService} from "src/app/security/console-context.service";

export class TokenInterceptorHandler {
  constructor(private auth: ConsoleAuthenticationService,
              private currentContext: ConsoleContextService) {
  }

  public handleRequest(req: HttpRequest<any>): HttpRequest<any> {
    const headers = new HttpHeaders(this.addSysContextHeaders(req));
    const cloned = req.clone({
      headers: headers
    });
    return cloned;
  }

  private addSysContextHeaders(req: any) {
    let headersObject: { [key: string]: any } = {
      'x-system-id': 'CONSOLE'
    }

    if (this.auth.getToken()) {
      headersObject['Authorization'] = `Bearer ${this.auth.getToken()}`;
    }

    const context = {
      landlordId: this.currentContext.getCurrentLandlordId() ?? null,
      locationId: this.currentContext.getCurrentLocation()?.uuid ?? null,
      offeringId: this.currentContext.getCurrentOfferingId() ?? null
    };


    if (context.landlordId != null) {
      headersObject['x-landlord-id'] = context.landlordId;
    }

    if (context.locationId != null) {
      headersObject['x-location-id'] = context.locationId;
    }

    if (context.offeringId != null) {
      headersObject['x-offering-id'] = context.offeringId?.toUpperCase()!;
    }

    req.headers.keys().forEach((ea: string) => {
      headersObject[ea as keyof Object] = req.headers.get(ea);
    })

    return Object.entries(headersObject)
      .reduce((a, [k, v]) => (v === null ? a : (a[k as keyof Object] = v, a)), {});
  }
}

export const tokenInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const auth: ConsoleAuthenticationService = inject(ConsoleAuthenticationService);
  const context: ConsoleContextService = inject(ConsoleContextService);
  const tokenInterceptorHandler = new TokenInterceptorHandler(auth, context);
  const cloned = tokenInterceptorHandler.handleRequest(req);
  return next(cloned);
}
